import { BaseMessage } from './BaseMessage';
import { MAP_GIT_PROVIDERS } from 'common/constants/GitTypes';
import { StyledRepoText } from './Notifications.style';

const DeletedGitIntegrationMessage = props => {
  const { sensor_authorization_name: sensorAuthName, sensor_id: sensorId } =
    props.extra_data || {};
  const providerMap = MAP_GIT_PROVIDERS[sensorId];
  const ProviderLogo = providerMap?.logo;

  if (!sensorAuthName) return null;

  return (
    <BaseMessage
      {...props}
      icon={ProviderLogo}
      title={sensorAuthName}
      description={
        <StyledRepoText>
          The integration has been successfully removed
        </StyledRepoText>
      }
    />
  );
};

export default DeletedGitIntegrationMessage;
